export interface EnvironmentModel {
  production: boolean;
  sentryTraceSampleRate: number;
  sentryDSN: string;
  apiUrl: string;
  apiSecret: string;
  platform?: string;
  appTitle?: string;
  appSubtitle?: string;
  displayAllSearchFilters?: boolean;
}
